import { cx } from 'emotion'
import React, { useCallback, useState } from 'react'
import styled from 'react-emotion'

import themeVars from 'ui_theme/site/globals/site.variables'

export default styled(HiddenFields)`
  margin-top: ${themeVars.large};

  .HiddenFields-trigger {
    color: ${themeVars.ultraLight};
    cursor: pointer;
    font-size: ${themeVars.tiny};
    font-weight: ${themeVars.graphikWeightMedium};
    text-align: right;
  }
  .HiddenFields-fields {
    height: 0;
    overflow: visible;
    opacity: 0;
    transition: opacity ease 300ms;

    &.shown {
      height: auto;
      opacity: 1;
    }
  }
`
function HiddenFields({ children, className, initiallyShown = true }) {
  const [shown, setShown] = useState(initiallyShown)
  const doToggleAreHiddenFieldsShow = useCallback(
    () => {
      setShown(!shown)
    },
    [shown, setShown]
  )

  return (
    <div className={className}>
      <div
        className="HiddenFields-trigger"
        onClick={doToggleAreHiddenFieldsShow}
      >
        {shown ? '- Hide additional fields' : '+ Show additional fields'}
      </div>
      <div className={cx('HiddenFields-fields', { shown })}>{children}</div>
    </div>
  )
}
